import { Typography, Grid, Box, useMediaQuery } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import KenButton from "../../../../GlobalComponents/KenButton";
import { useStyles } from "../../style";
import flamelogo1 from "../../../../Assets/flamelogo1.svg";
import AlumniIdBg from "../../../../Assets/AlumniIdCardBg.jpg";
import idcard from "../../../../Assets/idcard.png";
import defaultProfile from "../../../../Assets/DefaultProfile.png";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",          // full width on desktop
  maxWidth: 500,         // maximum width
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,                  // increased padding
  overflowY: "auto",
  maxHeight: "95vh",     // increased max height
};


const IdCard = (props: any) => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:1025px)");

  const {
    accountDetails,
    alumniDetails,
  } = props?.IdCardData || {};

  return (
    <Box sx={style}>
      {/* Header */}
      <Grid container justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Alumni ID card
        </Typography>
        <CloseIcon
          onClick={props.handleClose}
          sx={{ cursor: "pointer", fontSize: 20 }}
        />
      </Grid>
      <hr style={{ border: "1px solid #E6E6E8", marginBottom: 16 }} />

      {/* ID Card Container */}
      <Box
        sx={{
          width: "100%",
          height: isMobile ? 180 : 220,
          backgroundColor: "#3B61A7",
          borderRadius: 2, // 16px
          display: "flex",
          padding: isMobile ? 2 : 3,
          position: "relative",
          color: "white",
          boxSizing: "border-box",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        {/* Left side info */}
        <Box sx={{ flex: 2, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <Box>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: isMobile ? 18 : 20,
                mb: 1,
                letterSpacing: 0.5,
              }}
            >
              {accountDetails?.FirstName} {accountDetails?.LastName}
            </Typography>
            <Typography sx={{ fontSize: isMobile ? 14 : 16, mb: 0.5 }}>
              ID {alumniDetails?.Registration_Number__c || "N/A"}
            </Typography>
            <Typography sx={{ fontSize: isMobile ? 14 : 16 }}>
              Alumni ID card
            </Typography>

            {/* QR code container */}
            <Box
              sx={{
                width: 80,
                height: 80,
                backgroundColor: "white",
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <img
                src={alumniDetails?.QR_Code_URL__c}
                alt="QR code"
                style={{
                  maxWidth: "80%",
                  maxHeight: "80%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
        </Box>

        {/* Right side profile & year */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Box
            component="img"
            src={accountDetails?.Profile_Picture_URL__c || defaultProfile}
            alt="Profile"
            sx={{
              width: isMobile ? 100 : 120,
              height: isMobile ? 120 : 140,
              borderRadius: 1,
              border: "2px solid white",
              objectFit: "cover",
              mb: 1,
            }}
          />
          <Typography
            sx={{
              writingMode: "vertical-rl",
              textOrientation: "upright",
              fontWeight: "700",
              fontSize: isMobile ? 20 : 17,
              position: "absolute",
              right: -20,
              top: "30%",
              transform: "translateY(-50%)",
              color: "white",
            }}
          >
            {alumniDetails?.Year_of_Graduation__c || ""}
          </Typography>
        </Box>
      </Box>

      {/* Action Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 1 : 2,
        }}
      >
        <KenButton
          variant="text"
          className={classes.button}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            color: "#373A45",
            width: isMobile ? "100%" : "auto",
            "&:hover": { backgroundColor: "transparent" },
          }}
          onClick={props.handleClose}
        >
          Cancel
        </KenButton>

        {props?.IdCardData?.alumniDetails?.ID_Card_URL__c && (
          <KenButton
            variant="contained"
            className={classes.button}
            sx={{
              borderRadius: 2,
              boxShadow: "none",
              width: isMobile ? "100%" : "auto",
              "&:hover": { boxShadow: "none" },
            }}
            onClick={() => {
              const link = document.createElement("a");
              link.href = props?.IdCardData?.alumniDetails?.ID_Card_URL__c;
              link.download = "idcard.pdf";
              link.click();
            }}
          >
            Download
          </KenButton>
        )}
      </Box>
    </Box>
  );
};

export default IdCard;
